module.exports = __webpack_public_path__ + "static/media/carousel-2.ffd39a58.jpg";